<script>
    import { doc } from "firebase/firestore";
    import primaryLogo from "$lib/assets/images/logos/c2-logo-check.svg";
    import NavLinks from "./NavLinks.svelte";
    import ClassicLogo from "$lib/assets/images/logos/autocerts-classic-logo-sq-yellow.svg";
    import { page } from "$app/stores";
</script>

<header class="sticky top-0 z-50 w-full bg-white/95 backdrop-blur shadow-sm">
    <div class="max-w-screen-lg mx-auto px-4">
        <div class="flex flex-col md:flex-row justify-between items-center py-4 gap-4">
            <a href="/" class="transition-transform hover:scale-105">
                {#if $page.url.pathname === "/classic"}
                    <img class="w-36" src={ClassicLogo} alt="C2 Certification Logo" title="Return to Homepage" />
                {:else}
                    <img class="w-36" src={primaryLogo} alt="C2 Certification Logo" title="Return to Homepage" />
                {/if}
            </a>
            <NavLinks />
        </div>
    </div>
</header>

<style>
    /* Clean up unused styles */
</style>
